module.exports = __webpack_public_path__ + "img/image2.fe69a991.jpg";